import React from "react";
import styles from "./warnings.module.scss";

export const InputWarning = ({ children }) => {
  return <label className={styles.error}>{children}</label>;
};
